import { Link, useLocation } from "wouter";
import { QrCode } from "lucide-react";

// Site footer — shared by the home page and other public pages.
export function Footer() {
  const [, navigate] = useLocation();
  // On the home page "Pricing" scrolls to the pricing section; elsewhere it opens /pricing.
  const goPricing = () => {
    const el = document.getElementById("pricing");
    if (el) el.scrollIntoView({ behavior: "smooth" });
    else navigate("/pricing");
  };
  return (
    <footer className="bg-[#000000] text-[#ffffff] py-14 px-6">
      <div className="max-w-6xl mx-auto">

        {/* Top row — logo + columns */}
        <div className="flex flex-col md:flex-row justify-between items-start gap-10 mb-10">

          {/* Brand blurb */}
          <div className="shrink-0 max-w-[200px]">
            <Link href="/" className="flex items-center gap-2 mb-3">
              <QrCode size={18} className="text-indigo-400" />
              <span className="font-semibold text-sm text-[#ffffff] tracking-tight">CommonQR</span>
            </Link>
            <p className="text-xs leading-relaxed text-[#ffffff]">
              The universal QR identity &amp; interaction platform. One code. Every touchpoint.
            </p>
          </div>

          {/* Link columns */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-8 text-xs">

            {/* Product */}
            <div className="flex flex-col gap-2.5">
              <p className="text-[10px] font-semibold text-[#ffffff] tracking-[0.08em] uppercase mb-0.5">Product</p>
              <Link href="/demos"      className="text-[#888888] hover:text-[#ffffff] transition-colors">Demos</Link>
              <Link href="/use-cases"  className="text-[#888888] hover:text-[#ffffff] transition-colors">Use Cases</Link>
              <Link href="/explore"    className="text-[#888888] hover:text-[#ffffff] transition-colors">Explore Profiles</Link>
              <button
                onClick={goPricing}
                className="text-left text-[#888888] hover:text-[#ffffff] transition-colors"
              >
                Pricing
              </button>
            </div>

            {/* For Whom */}
            <div className="flex flex-col gap-2.5">
              <p className="text-[10px] font-semibold text-[#ffffff] tracking-[0.08em] uppercase mb-0.5">For Whom</p>
              <Link href="/brands"           className="text-[#888888] hover:text-[#ffffff] transition-colors">Brands</Link>
              <Link href="/businesses"       className="text-[#888888] hover:text-[#ffffff] transition-colors">Businesses</Link>
              <Link href="/professionals"    className="text-[#888888] hover:text-[#ffffff] transition-colors">Professionals</Link>
              <Link href="/celebrities"      className="text-[#888888] hover:text-[#ffffff] transition-colors">Celebrities</Link>
              <Link href="/products"         className="text-[#888888] hover:text-[#ffffff] transition-colors">Products</Link>
              <Link href="/local-businesses" className="text-[#888888] hover:text-[#ffffff] transition-colors">Local Businesses</Link>
            </div>

            {/* Use Cases */}
            <div className="flex flex-col gap-2.5">
              <p className="text-[10px] font-semibold text-[#ffffff] tracking-[0.08em] uppercase mb-0.5">Use Cases</p>
              <Link href="/business-card"      className="text-[#888888] hover:text-[#ffffff] transition-colors">Business Cards</Link>
              <Link href="/product-packaging"  className="text-[#888888] hover:text-[#ffffff] transition-colors">Product Packaging</Link>
              <Link href="/restaurant-menu"    className="text-[#888888] hover:text-[#ffffff] transition-colors">Restaurant Menus</Link>
              <Link href="/storefront"         className="text-[#888888] hover:text-[#ffffff] transition-colors">Storefronts</Link>
              <Link href="/event-pass"         className="text-[#888888] hover:text-[#ffffff] transition-colors">Event Passes</Link>
              <Link href="/social-hub"         className="text-[#888888] hover:text-[#ffffff] transition-colors">Social Hub</Link>
              <Link href="/ad-campaign"        className="text-[#888888] hover:text-[#ffffff] transition-colors">Ad Campaigns</Link>
              <Link href="/highway-hoarding"   className="text-[#888888] hover:text-[#ffffff] transition-colors">Highway Hoardings</Link>
            </div>

            {/* Account */}
            <div className="flex flex-col gap-2.5">
              <p className="text-[10px] font-semibold text-[#ffffff] tracking-[0.08em] uppercase mb-0.5">Account</p>
              <Link href="/signup"    className="text-[#888888] hover:text-[#ffffff] transition-colors">Sign up free</Link>
              <Link href="/login"     className="text-[#888888] hover:text-[#ffffff] transition-colors">Log in</Link>
              <Link href="/dashboard" className="text-[#888888] hover:text-[#ffffff] transition-colors">Dashboard</Link>
            </div>

          </div>
        </div>

        <div className="h-px bg-[#222222] mb-5" />
        <p className="text-xs text-center text-[#666666]">
          &copy; {new Date().getFullYear()} CommonQR. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
